module.exports = __webpack_public_path__ + "img/203.c511124.svg";